import Style from "ol/style/Style";
import Stroke from "ol/style/Stroke";
import Fill from "ol/style/Fill"
import Circle from "ol/style/Circle"
import Icon from 'ol/style/Icon';
import Text from 'ol/style/Text';

function twoColorStyle(outerColor,innerColor)   {
	var styleCache = {};
	styleCache.polygon = [
		
		new Style({
	        stroke: new Stroke({
	          color: outerColor,
	          width: 6
	        }),
	        fill: new Fill({
	        	color:'rgba(255, 255, 255, 0.2)'
	        })
	      }),
	      new Style({
		        stroke: new Stroke({
		          color: innerColor,
		          width: 2
		        })
		      })
	]
	styleCache.point = [
		new Style({
			image : new Circle({
	            radius : 6,
	            fill : new Fill({
	              color : outerColor
	            })
	          }),
	          geometry : function (feature) {
		             
	                return feature.getGeometry().getInteriorPoints()
	              
	              
	            }
	      }),
	      new Style({
	    	  image : new Circle({
		            radius : 3,
		            fill : new Fill({
		              color : innerColor
		            })
		          }),
		      
		      geometry : function (feature) {
	             
	                return feature.getGeometry().getInteriorPoints()
	              
	              
	            }
	      })
	]
	
	var styleFunction = function(feature,resolution) {
		if(resolution < 20) {
			return styleCache.polygon;
		}else {
			return styleCache.point;
		}
		
	}
	return styleFunction;
}
function highliteStyle() {
    var parcelHighliteStyle = new Style({
                    image: new Icon({
                      anchorXUnits: 'fraction',
                      anchorYUnits: 'fraction',
                      anchor:[0.5,1],
                        scale:0.5,
                      src: contextPath+"/resources/images/locationRed.png"
                    }),
                    geometry : function (feature) {
                        if(typeof(feature.getGeometry().getInteriorPoints) === "function") {
                            return feature.getGeometry().getInteriorPoints();
                        }else {
                            return feature.getGeometry();
                        }
	                   
	               }
               })
    return parcelHighliteStyle;
    
}
function selectParcelStyle() {
    var styleCache={};
    styleCache.big = [new Style({
			image : new Circle({
	            radius : 16,
	            fill : new Fill({
	              color: "rgba(255,0,0,0.7)"
	            })
	          }),
	          geometry : function (feature) {
  
	               return feature.getGeometry().getInteriorPoints()
	            }
    })];
    styleCache.small = [new Style({
	        stroke: new Stroke({
	          color: "red",
	          width: 6
	        })
	      })];
    
    var selectStyleFunc = function(feature,resolution) {
        if(resolution < 20) {
			return styleCache.small;
		}else {
			return styleCache.big;
		}
    }
    return selectStyleFunc;
}
var realestateColors = {
	low : "rgba(38,91,178,0.5)",
	middle : "rgba(38,91,178,0.5)",
	high : "rgba(38,91,178,0.5)",
	main : "rgba(38,91,178,0.9)"
};
var realestateSelectColors = {
	low : "rgba(255,13,17,0.5)",
	middle : "rgba(255,13,17,0.5)",
	high : "rgba(255,13,17,0.5)",
	main : "rgba(255,13,17,0.9)"
};

function createRealestateStyle(fillColor,strokeColor,strokeWidth,radius,label) {
    return new Style({
      image : new Circle({
            radius : radius,
            fill : new Fill({
              color : fillColor
            }),
              stroke: new Stroke({
                  width:strokeWidth,
                  color: strokeColor
              })
          }),
       text: new Text({
           text: label + "",
           font:"bold 11px serif",
           fill: new Fill({
                color: 'white'
            })
       })
    });
    
} 



function realestateStyleFunction(isSelectStyleIn) {
    var styleCache = {}
    var isSelectStyle=isSelectStyleIn;
    return function(feature,resolution) {
        var classifyCount = feature.get("count");
        if(classifyCount > 1 && classifyCount <= 15 ) {
            classifyCount = "2_15";
        }else if(classifyCount > 15 && classifyCount <=50) {
            classifyCount = "15_50";
        }else if(classifyCount > 50 ) {
             classifyCount = "50_";  
        }
        var colors=isSelectStyleIn?realestateSelectColors:realestateColors;
        var key = (feature.get("count") > 1)?feature.get("count")+"":feature.get("category");
        if(!styleCache[key]) {
            if(classifyCount === "2_15") {
                styleCache[key] = createRealestateStyle(colors.main,colors.low,12,10,feature.get("count"));
            }else if(classifyCount === "15_50") {
                styleCache[key] = createRealestateStyle(colors.main,colors.middle,12,15,feature.get("count"));
            } else if(classifyCount === "50_") {
                styleCache[key] = createRealestateStyle(colors.main,colors.high,12,20,feature.get("count"));
            } else {
                styleCache[key] = new Style({
                    image: new Icon({
                      anchorXUnits: 'fraction',
                      anchorYUnits: 'fraction',
                      anchor:[0.5,1],
                      src: iconMapping.getIconPath(feature.get("category"),isSelectStyle)
                    })
               })
            }
        }
        
        return styleCache[key];
    }
    
}


var iconMapping = {
		
		getIconPath : function(type,select) {
			var iconPath = this[type];
			
			if(select) {
				return iconPath.replace("1.","_red1.");
			}else {
				return iconPath;
			}
		},
		/**
         * Büro und Praxis.
         */
        OFFICE: contextPath+ "/javax.faces.resource/iconsetA/workoffice1.png.xhtml?ln=img",
									
        /**
         * Einzelhandel/ Ladenlokale.
         */
        RETAIL: contextPath+ "/javax.faces.resource/iconsetA/supermarket1.png.xhtml?ln=img",
        /**
         * Ladenlokal und Büro.
         */
        RETAIL_OFFICE: contextPath+ "/javax.faces.resource/iconsetA/supermarket1.png.xhtml?ln=img",
        /**
         * Gastgewerbe.
         */
        GASTRONOMY: contextPath+ "/javax.faces.resource/iconsetA/restaurant1.png.xhtml?ln=img",
        /**
         * Industrie: Lager, Hallen und Produktion.
         */
        INDUSTRY: contextPath+ "/javax.faces.resource/iconsetA/factory1.png.xhtml?ln=img",
        /**
         * Industrie mit Büro.
         */
        INDUSTRY_OFFICE: contextPath+ "/javax.faces.resource/iconsetA/factory1.png.xhtml?ln=img",
        /**
         * Industrie mit Ladenlokal.
         */
        INDUSTRY_RETAIL: contextPath+ "/javax.faces.resource/iconsetA/factory1.png.xhtml?ln=img",
        /**
         * Industrie mit Ladenlokal und Büro
         */
        INDUSTRY_RETAIL_OFFICE: contextPath+ "/javax.faces.resource/iconsetA/factory1.png.xhtml?ln=img",
        /**
         * Land- und Forstwirtschaft.
         */
        AGRICULTURE_FORESTRY: contextPath+ "/javax.faces.resource/iconsetA/agriculture1.png.xhtml?ln=img",
        /**
         * Sonstige
         */
        OTHER: contextPath+ "/javax.faces.resource/iconsetA/office-building1.png.xhtml?ln=img"
		
};

export default {
    twoColorStyle:twoColorStyle,
    realestateStyleFunction:realestateStyleFunction,
    selectParcelStyle:selectParcelStyle,
    highliteStyle:highliteStyle
}
